// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
const { APIPost, APIGet } = require('utilities/APIRequestHelper');
const { map, contains, isEmpty, omit } = require('lodash');

// @ utilities
const { recordProcess, PROC_END, PROC_FAIL } = require('utilities/tagging');
const { dataTypes, fieldsByType } = require('components/mortgageRequest/mortgageRequestEstates/initialValues');
// @ track processes
const { PROC_ADD_ESTATES_DATA } = require('constants/mortgageRequestProcesses');

// @ actions
const { requestInmuebles, resetInmuebles } = require('actions/mortgageRequest/mortgageRequestInmuebles');
const { requestState } = require('actions/mortgageRequest/mortgageRequestState');

// @ constants
const { VIVIENDA } = require('constants/mortgageRequestEstates').ESTATES_TYPE_ABBREVIATION;
const actionTypes = require('constants/actionTypes');


const resetSummaryDocumentationReducer = () => ({
    type: actionTypes.MORTGAGE_REQUEST_SUMMARY_DOCUMENTATION_RESET
});

const updateEstateInProgress = () => ({
    type: actionTypes.MORTGAGE_REQUEST_ESTATES_UPDATE_REQUEST
});

const updateEstateSuccess = estate => ({
    type: actionTypes.MORTGAGE_REQUEST_ESTATES_UPDATE_SUCCESS,
    data: { estate }
});


const updateEstateFailure = error => ({
    type: actionTypes.MORTGAGE_REQUEST_ESTATES_DELETE_FAILURE,
    data: { error }
});

const deleteEstateReset = () => ({
    type: actionTypes.MORTGAGE_REQUEST_ESTATES_DELETE_RESET
});

const deleteEstateShowModal = showModal => ({
    type: actionTypes.MORTGAGE_REQUEST_ESTATES_DELETE_SHOW_MODAL,
    data: { showModal }
});

const deleteEstateInProgress = () => ({
    type: actionTypes.MORTGAGE_REQUEST_ESTATES_DELETE_REQUEST
});

const deleteEstateSuccess = propertyId => ({
    type: actionTypes.MORTGAGE_REQUEST_ESTATES_DELETE_SUCCESS,
    data: { propertyId }
});

const deleteEstateFailure = error => ({
    type: actionTypes.MORTGAGE_REQUEST_ESTATES_DELETE_FAILURE,
    data: { error }
});

const requestEstatesSaveAmmountInProgress = () => ({
    type: actionTypes.MORTGAGE_REQUEST_ESTATES_SAVE_AMMOUNT_REQUEST
});

const requestEstatesSaveAmmountSuccess = data => ({
    type: actionTypes.MORTGAGE_REQUEST_ESTATES_SAVE_AMMOUNT_SUCCESS,
    data
});

const requestEstatesSaveAmmountFailure = error => ({
    type: actionTypes.MORTGAGE_REQUEST_ESTATES_SAVE_AMMOUNT_FAILURE,
    data: { error }
});

const requestEstatesFetchAmmountInProgress = () => ({
    type: actionTypes.MORTGAGE_REQUEST_ESTATES_FETCH_AMMOUNT_REQUEST
});

const requestEstatesFetchAmmountSuccess = data => ({
    type: actionTypes.MORTGAGE_REQUEST_ESTATES_FETCH_AMMOUNT_SUCCESS,
    data
});

const requestEstatesFetchAmmountFailure = error => ({
    type: actionTypes.MORTGAGE_REQUEST_ESTATES_FETCH_AMMOUNT_FAILURE,
    data: { error }
});

const requestSummaryDocumentationInProgress = () => ({
    type: actionTypes.MORTGAGE_REQUEST_FETCH_SUMMARY_DOCUMENTATION_REQUEST
});

const requestSummaryDocumentationSuccess = data => ({
    type: actionTypes.MORTGAGE_REQUEST_FETCH_SUMMARY_DOCUMENTATION_SUCCESS,
    data
});

const requestSummaryDocumentationFailure = error => ({
    type: actionTypes.MORTGAGE_REQUEST_FETCH_SUMMARY_DOCUMENTATION_FAILURE,
    data: { error }
});

const requestSaveEstatesDone = () => ({
    type: actionTypes.MORTGAGE_REQUEST_ESTATES_SAVE_REQUEST_DONE
})

const requestResetEstates = () => ({
    type: actionTypes.MORTGAGE_REQUEST_ESTATES_DATA_RESET
});

const saveAmmounts = (ammounts, history) => (dispatch, getState) => {
    dispatch(requestEstatesSaveAmmountInProgress());
    const idExpediente = getState().mortgageRequestState.get('idExpediente');
    const url = apiURLBuilder.getURL(`mortgageRequestSaveEstatesAmmount`);

    const formData = {
        query: {
            viviendas: ammounts.livingPlace,
            trasteros: ammounts.storageRoom,
            garajes: ammounts.garage
        }
    };

    return APIPost(dispatch, `${url}?idExpediente=${idExpediente}`, formData)
        .then((response) => {
            dispatch(requestEstatesSaveAmmountSuccess(response));
            recordProcess(PROC_ADD_ESTATES_DATA, PROC_END);
            dispatch(requestState('/myprofile/mortgage/panel', history));
        })
        .catch(response => {
            if (!!response.error) {
                recordProcess(PROC_ADD_ESTATES_DATA, PROC_FAIL);
                dispatch(requestEstatesSaveAmmountFailure(response.error));
            } else {
                throw response;
            }
        });
};

const fetchAmmounts = () => (dispatch) => {
    dispatch(requestEstatesFetchAmmountInProgress());

    const url = `${apiURLBuilder.getURL('mortgageRequestFetchEstatesAmmount')}`;
    return APIGet(dispatch, url)
        .then((response) => dispatch(requestEstatesFetchAmmountSuccess(response)))
        .catch(response => {
            if (!!response.error) {
                dispatch(requestEstatesFetchAmmountFailure(response.error));
            } else {
                throw response;
            }
        });
};

const fetchSimpleNotes = () => (dispatch, getState) => {
    const idExpediente = getState().mortgageRequestState.get('idExpediente');
    const requestData = {
        query: {
            from: 0,
            howmany: 0,
            idExpediente
        }
    };

    dispatch(requestSummaryDocumentationInProgress());

    return APIPost({
        dispatch,
        endpoint: 'mortgageRequestSummaryDocumentation',
        params: requestData
    })
        .then(response => dispatch(requestSummaryDocumentationSuccess(response)))
        .catch(response => {
            if (!!response.error) {
                dispatch(requestSummaryDocumentationFailure(response.error));
            } else {
                throw response;
            }
        });
};

const filterEstateByType = estate => {
    if (estate.type === VIVIENDA) {

        return estate;
    }

    const data = {};

    map(estate, (value, name) => {
        data[name] = null;

        map(fieldsByType, (fields, type) => map(fields, field => {

            if (field === name && (contains(type, dataTypes.IGNORE) || type === estate.idtype)) {
                data[name] = value;
            }
        }))
    });

    return data;
};

const sendState = (idx, data, dispatch, history) => {

    if (idx < data.length) {

        if (isEmpty(data[idx])) {
            sendState(++idx, data, dispatch, history); // eslint-disable-line
        } else if (data[idx].delete) {
            const callbackFn = () => { sendState(++idx, data, dispatch, history) };
            dispatch(deleteEstate(data[idx].id, callbackFn)); // eslint-disable-line
        } else {

            if (data[idx].sameLivingPlaceAdress) {
                const livingPlaceIndex = 0;
                data[idx].streetType = data[livingPlaceIndex].streetType;
                data[idx].street = data[livingPlaceIndex].street;
                data[idx].streetNumber = data[livingPlaceIndex].streetNumber;
                data[idx].streetType = data[livingPlaceIndex].streetType;
                data[idx].provinceId = data[livingPlaceIndex].provinceId;
                data[idx].populationId = data[livingPlaceIndex].populationId;
                data[idx].postalCode = data[livingPlaceIndex].postalCode;
                data[idx].addressOthers = data[idx].estateNumberSameLivingPlace;
            }

            const estateData = filterEstateByType(data[idx]);

            return APIPost({
                dispatch,
                endpoint: 'mortgageRequestInmuebles',
                params: {
                    query: estateData
                }
            })
                .then(() => sendState(++idx, data, dispatch, history))
                .catch(response => {
                    if (!!response.error) {
                        recordProcess(PROC_ADD_ESTATES_DATA, PROC_FAIL);
                        dispatch(requestEstatesSaveAmmountFailure(response.error));
                        sendState(idx, data, dispatch, history);
                    } else {

                        throw response;
                    }
                });
        }
    } else {

        dispatch(requestSaveEstatesDone());

        history.push('/myprofile/mortgage/estates-successful-result');
    }
};

const saveEstates = (data, history) => (dispatch, getState) => {
    if (!getState().mortgageRequestEstates.get('isFetching')) {

        resetInmuebles()(dispatch);

        dispatch(requestEstatesSaveAmmountInProgress());

        sendState(0, data, dispatch, history);
    }
};

/**
 * siempre se debe hacer este request ya que es la V2 del endpoint.
 * En el panel se hace el request con la V1, la cual no trae la info necesaria para esta pag
 */
const getEstatesData = () => (dispatch, getState) => {

    requestInmuebles(true)(dispatch, getState);
};

const deleteEstate = (propertyId, callbackFn) => dispatch => {

    const url = apiURLBuilder.getURL(
        'mortgageRequestDeleteEstate',
        { propertyId }
    );

    dispatch(deleteEstateInProgress());

    return APIPost({
        dispatch,
        url
    })
        .then(() => {
            dispatch(deleteEstateSuccess(propertyId))
            callbackFn && callbackFn();
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(deleteEstateFailure(response.error));
            } else {
                throw response;
            }
        });

};

const showModal = show => dispatch => dispatch(deleteEstateShowModal(show));

const resetDeleteEstate = () => dispatch => dispatch(deleteEstateReset());

const updateEstate = estate => dispatch => {

    const newEstate = omit(estate.toJS(), [
        'populationData', 'populationList', 'provinceData', 'provinceList', 'registerList', 'registerData'
    ]);

    dispatch(updateEstateInProgress());

    return APIPost({
        dispatch,
        endpoint: 'mortgageRequestInmuebles',
        params: {
            query: newEstate
        }
    })
        .then(() => dispatch(updateEstateSuccess(estate)))
        .catch(response => {
            if (!!response.error) {
                dispatch(updateEstateFailure(response.error));
            } else {
                throw response;
            }
        });
};

const resetSummaryDocumentation = () => dispatch => dispatch(resetSummaryDocumentationReducer());

module.exports = {
    saveAmmounts,
    fetchAmmounts,
    fetchSimpleNotes,
    saveEstates,
    getEstatesData,
    requestResetEstates,
    deleteEstate,
    showModal,
    resetDeleteEstate,
    updateEstate,
    resetSummaryDocumentation
};
